export const DeliveryEstimateBanner = ({ merchant, onAddMore }: any) => {
  const storedCart = global?.window?.localStorage.getItem("cart");
  const cartItems = storedCart ? JSON.parse(storedCart) : [];
  const totalPrice =
    cartItems.reduce((total: number, i: any) => (total += i.value.total), 0) /
    100;
  const deliveryFee = merchant.deliveryFee;
  const hasMetMinimumFreeDelieveryPrice =
    merchant.deliveryOrderNoFeesAmount / 100 <= totalPrice;
  const hasMetMinimumDelivery = merchant.deliveryMinimum / 100 <= totalPrice;
  return (
    <>
      <div
        className={`rounded-lg   ${
          hasMetMinimumDelivery
            ? "bg-[#eefbfc] border-[#69D0DD]"
            : "bg-[#FFF6CC] border-[#FFD100]"
        } p-4`}
      >
        {hasMetMinimumFreeDelieveryPrice && (
          <p className="font-semibold text-[18px]">
            You&apos;ve earned free delivery on this order!
          </p>
        )}
        {deliveryFee !== undefined &&
          hasMetMinimumDelivery &&
          !hasMetMinimumFreeDelieveryPrice && (
            <>
              <p className="font-semibold text-[18px]">
                You&apos;re $
                {(
                  merchant.deliveryOrderNoFeesAmount / 100 -
                  totalPrice
                ).toFixed(2)}{" "}
                away from free delivery!
              </p>
              <p>
                <span
                  onClick={() => onAddMore && onAddMore()}
                  className="underline cursor-pointer"
                >
                  Add more to your cart
                </span>{" "}
                to remove delivery fees.
              </p>
            </>
          )}
        {!hasMetMinimumDelivery && (
          <>
            <p className="font-semibold text-[18px]">
              There&apos;s ${(merchant.deliveryMinimum / 100).toFixed(2)}{" "}
              minimum for delivery orders.
            </p>
            <p>
              <span
                onClick={() => onAddMore && onAddMore()}
                className="underline cursor-pointer"
              >
                Add more to your cart
              </span>{" "}
              to place your order.
            </p>
          </>
        )}
      </div>
    </>
  );
};
